<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Bulk Action</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h4>Obtaining customers for bulk action...</h4>

    <div class="progress">
      <div class="progress-bar" role="progressbar" [style]="{width: getProgressPercentageStr() + '%'}"
           attr.aria-valuenow="{{ getProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
  </div>

</ng-container>
